import React from 'react'

const OpticalCharacterRecognition = () => {
  return (
    <div
      className='card m-1 text-decoration-none align-items-center text-center'
      style={{
        width: '20rem',
        overflow: 'hidden',
        boxShadow: 'rgb(204, 204, 204) 2px 2px 9px',
        transform: 'scale(1)'
      }}
    >
      <img
        className='mt-4 w-100px h-100px'
        src='https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/assets/images/ocr.png'
        alt='Integration logo'
      />
      <div className='card-body align-items-center text-center'>
        <h5 className='card-title text-dark'>Optical Character Recognition</h5>
        <p className='card-text text-muted'>
          Experience the future of document management with Optical Character Recognition (OCR).
        </p>

        <button
          className='btn'
          style={{
            cursor: 'not-allowed',
            color: '#3f4254',
            borderColor: '#e4e6ef',
            backgroundColor: '#e4e6ef'
          }}
        >
          Coming Soon...
        </button>
      </div>
    </div>
  )
}

export default OpticalCharacterRecognition
